import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { Page } from "types/dto/Page";
import { RegistroCondominioDTO } from "types/dto/RegistroCondominioDTO";
import { RequestDespesaGroupPay } from "types/request/groupPay/RequestDespesaGroupPay";

export const useGetDespesasGroupPay = (request: RequestDespesaGroupPay) => {
  const onError = () => {
    toast.error("Erro ao buscar as despesas cadastradas");
  };

  const config = {
    staleTime: 1000 * 60 * 60 * 1,
    retry: 2,
  };

  return useFetch<Page<RegistroCondominioDTO>>({
    key: [
      "despesas-paginadas-group-pay",
      request.pesquisa,
      request.numeroDoc,
      request.tipoBusca,
      request.isHistorico,
      request.page,
      request.sort,
      request.mesCompetenciaSincronizacao,
      request.condominioId,
    ],
    url: api.groupPay.getDespesasPaginadasGroupPay,
    params: request,
    enabled: true,
    onError,
    config,
  });
};
